import { connect } from 'react-redux';
import PlayerDeleteForm from '../components/forms/PlayerDeleteForm';
import {withRouter} from 'react-router-dom';
import { clearPlayerAction, deletePlayerAction } from '../store/actions';
import {formValueSelector} from  'redux-form';

const mapDispatchToProps = ({
    onSubmit: deletePlayerAction,
    clearPlayer : clearPlayerAction
});

const mapStateToProps = (state, ownProps) => {
    const selector = formValueSelector('player');
    const player = state.player.data;
    player.gameId = ownProps.match.params.id;
    return {
        initialValues: player,
        image: selector(state, 'image')
    }
};


const PlayerDeleteFormContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(PlayerDeleteForm));


export default PlayerDeleteFormContainer;
